export const emptySection = (data) => {
  let isEmpty = true
  data.forEach((el) => {
    if (el.trad || el.content) {
      isEmpty = false
    }
  })

  return isEmpty
}
